import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';

export default class AbbreviationText extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false,
                DeleteAllPopup: false, hideDeleteAllPopup: false, hideIncorrectPassword: false
            });
        };

        this.DeletedialogClose = () => {
            this.setState({ hideTextAreaPopup: false });
        };
        this.IncorrectPassworddialogClose = () => {
            this.setState({ hideIncorrectPassword: false });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for update dialog component ok click
        this.Okbutton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchDataApi()
                this.dialogClose();
            }
        }];
        this.addedButton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchDataApi()
                this.dialogClose();
                this.setState({
                    disabled: false
                })
            }
        }];

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteAbbreviationApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }, {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        //deleteall text confirmation
        this.textAreaConfir = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': () => {
                this.deleteInputValidation()
            }
        }, {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideTextAreaPopup: false,
                });
            }
        }];
        //incorrectPasswordButtons
        this.incorrectPasswordButtons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': () => {
                this.setState({
                    hideTextAreaPopup: true,
                    hideIncorrectPassword: false

                })
            }
        }];

        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.fetchDataApi()
                this.setState({ disabled: false })
            }
        }];
        //deleteall
        this.deleteAllButton = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': () => {
                this.setState({
                    hideDeleteAllPopup: false,
                    hideTextAreaPopup: true
                });
            }
        }, {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeleteAllPopup: false,
                });
            }
        }];
        this.state = {
            data: [{
                id: '',
            }],
            hideIncorrectPassword: false,
            hideTextAreaPopup: false,
            disabled: false,
            editedId: '-1',
            contentEditable: "false",
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            successResp: false,
            pageNum: null,
            DeleteAllPopup: true,
            hideDeleteAllPopup: false
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.slotTypeList = [];


    }
    addRow = (data) => {
        var AbbreviationComponent = this;
        if (AbbreviationComponent.state.pageNum != 0) {
            AbbreviationComponent.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: ''
        });
        this.setState({
            data: this.state.data,
            disabled: true,
        })
    }
    deleteAllApi = () => {
        let deleteApiViewController = this;
        $.ajax({
            url: "/api/abbreviation/text/delete/all/",
            async: false,
            method: 'POST',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            data: {
                language: document.getElementById('language').value,
                projectId: localStorage.getItem('currentProjectId')
            },
            success: function (res) {

                if (res.success === true && res.result === "done.") {
                    deleteApiViewController.state.hideTextAreaPopup = false;
                    deleteApiViewController.state.checkBoxRows = [];
                    deleteApiViewController.setState(deleteApiViewController.state);
                    deleteApiViewController.fetchDataApi();
                    deleteApiViewController.notifyDeleteAll();
                } else if (res.success === true && res.result != "done.") {
                    deleteApiViewController.notifyNodata(res.result);
                } else {
                    deleteApiViewController.notifyFailedDelete(res.result);
                }
            },

            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });
    }
    notifyFailedDelete(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });


    }

    notifyNodata(response) {

        this.setState({
            hideTextAreaPopup: false
        })
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });


    }

    deleteInputValidation = () => {
        if (document.getElementById('deleteInputFromUser').value == "Delete" ||
            document.getElementById('deleteInputFromUser').value == "delete" ||
            document.getElementById('deleteInputFromUser').value == "DELETE") {
            document.getElementById('deleteInputFromUser').value = "";
            this.deleteAllApi();
        }
        else {
            this.setState({
                hideIncorrectPassword: true
            })
        }
    }

    validateResult(abbreviation, expansion) {
        if (abbreviation == "" || expansion == "") {
            this.notifyEmptyFieldForAdd();
            return false;
        } else {
            return true;
        }
    }

    saveAbbreviationApi(props, e) {
        var language = document.getElementById('language').value;
        var abbreviation = document.getElementById("abbreviation" + props.index).innerText.trim();
        var expansion = document.getElementById("expansion" + props.index).innerText.trim();
        this.state.editedId = "-1";
        this.setState(this.state);
        if (this.validateResult(abbreviation, expansion)) {
            var addedData = {
                projectId: localStorage.getItem('currentProjectId'),
                language: language,
                slotType: document.getElementById('slotType' + props.index).value,
                abbreviation: abbreviation,
                expansion: expansion
            };
            var addMltController = this
            $.ajax({
                url: "/api/abbreviation/text",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(addedData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        addMltController.notifyAdded();
                        addMltController.fetchDataApi();
                        addMltController.setState({ disabled: false })
                    } else {
                        addMltController.notifyFailedResponse(res.result);
                    }
                },
                error: function (xhr, status, error) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            })
        }
    }
    updateAbbreviationApi(props, e) {
        var language = document.getElementById('language').value;
        var abbreviation = document.getElementById("abbreviation" + props.index).innerText.trim();
        var expansion = document.getElementById("expansion" + props.index).innerText.trim();
        var updatedDataController = this
        if (updatedDataController.validateResult(abbreviation, expansion)) {
            var updatedData = {
                id: props.original.id,
                projectId: localStorage.getItem('currentProjectId'),
                language: language,
                slotType: document.getElementById('slotType' + props.index).value,
                abbreviation: abbreviation,
                expansion: expansion
            };
            $.ajax({
                url: "/api/abbreviation/text",
                async: false,
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(updatedData),
                processData: false,
                success: function (res) {
                    if (res.success === true) {
                        updatedDataController.state.editedId = "-1";
                        updatedDataController.notifyUpdate();
                        updatedDataController.fetchDataApi();
                    } else {
                        updatedDataController.notifyFailedResponse(res.result);
                    }
                },
                error: function (xhr, status, error) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            })
        }
    }

    makeCelledit(props, e) {
        this.markAsBeingEdited(this.state.data[props.index].id);
    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }


    deleteAbbreviationApi = (id) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(id, 1);
        } else {
            $.ajax({
                url: "/api/abbreviation/text/" + id,
                async: false,
                method: 'DELETE',
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteConstructorVariables.notifyDelete();
                        deleteRowViewController.splice(id, 1);
                    } else {
                        deleteRowViewController.NotifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            });
        }

        if (this.state.deleteRow) {
            this.state.data.splice(id, 1);
        }
        deleteConstructorVariables.fetchDataApi();


    }


    componentDidMount() {
        this.language = document.getElementById('language').value;
        setTimeout(() => {
            this.fetchLanguageApi();
            this.fetchSlotTypeApi();
            this.fetchDataApi();
        }, 300);

        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            if (document.getElementById('language') != null) {
                thisController.projectId = event.projectId;
                thisController.fetchLanguageApi(event.projectId);
                thisController.fetchSlotTypeApi();
                thisController.fetchDataApi(event.projectId);
                thisController.language = document.getElementById('language').value;
                thisController.projectId = localStorage.getItem('currentProjectId');
            }
        });

    }

    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.fetchDataApi()
        this.setState({ disabled: false })
    }


    fetchDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        let AbbreviationComponent = this;
        $.ajax({
            url: "/api/abbreviation/text",
            async: false,
            method: 'GET',

            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },
            data: {
                projectId: projectId,
                language: document.getElementById('language').value
            },
            success: function (res) {
                if (res.success === true) {
                    AbbreviationComponent.setState({
                        data: res.result,
                        successResp: true,
                        disabled: false
                    })
                } else {
                    AbbreviationComponent.notifyFailedResponse(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });
    }

    notifyDeleteAll() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
                content="" />&nbsp;&nbsp;All abbreviations have been deleted Successfully</b>, {
            position: "top-center",
        });

    }
    notifyAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Abbreviation Added Successfully</b>, {
            position: "top-center",
        });
    }

    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }

    notifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Abbreviation Updated Successfully</b>, {
            position: "top-center",
        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Abbreviation Deleted Successfully</b>, {
            position: "top-center",
        });
    }

    notifyEmptyFieldForAdd() {
        toast.dismiss();
        toast(<b> Please fill all the data</b>, {
            position: "top-center"
        });
    }


    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }


    //----------------------------------------------------------------------------------------------
    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    //--------------------------------------LANGUAGE_API-------------------------------------------------------------
    fetchLanguageApi(projectId) {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var languageController = this;
        $.ajax(
            {
                url: "/api/project-languages-selected",
                async: false,
                method: 'GET',
                data: {
                    projectId: projectId,
                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json'
                },
                success: function (res) {
                    if (res.success === true) {
                        var language = res.result;
                        languageController.setState({ language: language });
                        var numberOfLanguages = language.length;
                        var ele3 = document.getElementById("language");
                        if (ele3 != "") {
                            if (ele3 != null) {
                                ele3.innerHTML = "";
                                for (var i = 0; i < numberOfLanguages; i++) {
                                    ele3.innerHTML = ele3.innerHTML + '<option value="' + language[i]['code'] + '">' + language[i]['code'] + '</option>';
                                }
                            }
                        }
                        successResp: true
                    } else {
                        languageController.notifyFailedResponse(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            }
        )
    }

    //--------------------------------------------------------------------------------------------------------------
    handleChangeForLanguage = (event) => {
        this.setState({
            value: event.target.value,
            language: document.getElementById('language').value
        });
        this.fetchDataApi();
    }

    fetchSlotTypeApi = () => {
        let AbbreviationComponent = this;
        $.ajax({
            url: "/api/slotTypes",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    AbbreviationComponent.slotTypeList = res.result;
                    AbbreviationComponent.setState(AbbreviationComponent.state);
                }
            },
            error: function (xhr, status, error) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    slotTypeHandleChange(props, e) {
        props.original.abbreviation = document.getElementById("abbreviation" + props.index).innerText.trim();
        props.original.expansion = document.getElementById("expansion" + props.index).innerText.trim();
        props.original.slotType = e.target.value;
        this.setState(this.state);
    }
    render() {
        const { data } = this.state
        const columns = [{
            Header: () => <b>Abbreviation</b>,
            accessor: 'abbreviation',
            Cell: props => (
                <div name="code">
                    <div className="textarea"
                        style={{
                            background: 'white', height: "2.7em", resize: 'none', paddingLeft: '2px', paddingTop: '6px', width: '98%',
                            border: (props.original.id == "" || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                            borderRadius: (props.original.id == "") ? '2px' : 'none'
                        }}
                        id={"abbreviation" + props.index}
                        contentEditable={!((props.original.id == "" ) ? false :
                            props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        >{props.original.abbreviation}
                    </div>
                </div>)
        }, {
            Header: () => <b>Expansion</b>,
            accessor: 'expansion',
            Cell: props => (
                <div name="text">
                    <div className="textarea"
                        style={{
                            background: 'white', height: "2.7em", resize: 'none', paddingLeft: '2px', paddingTop: '6px',
                            width: '98%',
                            border: (props.original.id == "" || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                            borderRadius: (props.original.id == "") ? '2px' : 'none'
                        }}
                        id={"expansion" + props.index}
                        contentEditable={!((props.original.id == "") ? false :
                            props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        >{props.original.expansion}
                    </div>
                </div>)
        }, {
            Header: <b>Slot Type</b>,
            accessor: 'customType',
            width: 150,
            sortable: false,
            Cell: props => {
                return (
                    <div className="container-fluid"  >
                        <select className="input-group form-control select2 "
                            onChange={(e) => this.slotTypeHandleChange(props, e)}
                            multiple={false}
                            value={props.original.slotType}
                            id={'slotType' + props.index}
                            style={{ background: 'white', border: 'none' }}
                            disabled={(props.original.id != "") ? props.original.id != this.state.editedId : false}>
                            {this.slotTypeList.map(slotType => (
                                <option key={slotType.code} value={slotType.code} >
                                    {slotType.name}
                                </option>
                            ))}
                        </select>
                    </div>
                )
            },
        }, {
            Header: <b>Action</b>,
            accessor: 'action',
            width: 200,
            Cell: props => (
                <div id="action">
                    <button style={{ backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px' }} >
                        <img className="img-responsive"
                            title={(props.original.id == "") ||
                                (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                            style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                            src={(props.original.id == "") ? this.saveImageSrc : ((props.original.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                            onClick={(e) => {
                                (props.original.id == "") ? this.saveAbbreviationApi(props, e) : (props.original.id == this.state.editedId) ?
                                    this.updateAbbreviationApi(props, e) : this.makeCelledit(props, e);
                            }} />
                    </button>
                    <button style={{
                        backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px'
                    }} title="Delete">
                        <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                            style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                            onClick={() => (props.original.id) === '' ?
                                this.fetchDataApi() :
                                this.setState({
                                    hideDeletePopup: true, deletePropIndex: props.index, propsId: props.original.id
                                })} /></button>
                </div>),
            width: 100
        }
        ]
        return (
            <div style={{ marginRight: '1%' }}>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!this.state.successResp}
                    height={300} width={50}
                    style={{ textAlign: 'center' }}
                />
                <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }} >
                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    {/*for dialog component */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <div className="row" style={{ marginLeft: "15px" }}>
                        <div className="col-sm-4" style={{ marginTop: '2px' }} >
                            <label >Language</label>
                            <select className="language"
                                id="language" value={this.state.value}
                                onChange={this.handleChangeForLanguage}
                                style={{ marginLeft: "15px", width: '53%', height: '30px', borderRadius: '4px', backgroundColor: '#F9F9FB' }}>
                            </select>
                        </div>
                    </div>

                    <div className="row" style={{ marginLeft: '14px' }}>
                        <div className="col-sm-5">
                            <h6 className="nav-item" style={{ color: '#282a65', marginTop: '15px' }}>Abbreviation Text</h6>
                        </div>
                        <div className="col-sm-5" Align="right">
                            {/* <button className="btn action-button" style={{ marginTop: '0px' }}
                                id="addMsg" title=" Delete All "
                                onClick={() => {
                                    this.setState({
                                        hideDeleteAllPopup: true
                                    })
                                }}>
                                Delete All
                            </button> */}
                        </div>
                        {/* Add button */}
                        <div className="col-sm-2 " style={{ marginTop: '-18px' }}>
                            <div className="d-flex flex-row-reverse pt-2">
                                <div className="p-2" style={{ marginBottom: '10px' }}>

                                    <button className="btn action-button"
                                        id="addMsg" title=" Add "
                                        onClick={this.state.disabled ? this.notifyEmptyFieldForAdd : this.addRow}>
                                        <img src="assets/images/add_white_24dp.png" />
                                    </button>
                                    <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                                        <img src="./assets/images/refresh_white_24dp.png"></img></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ marginLeft: '15px', marginTop: '-15px' }}>
                        <div className="col-lg-12 ">
                            <div className="card">
                                <ReactTable
                                    data={data}
                                    columns={columns}
                                    defaultPageSize={10}
                                    pageSizeOptions={[5, 10, 15]}
                                    onPageChange={this.onPageChange}
                                    page={this.state.pageNum}

                                />
                            </div>
                            <ToastContainer className="Toast-at-center" />
                            {/*Dialog Component For Deletion Confirmation*/}
                            <DialogComponent width='400px' animationSettings={this.settings}
                                header='Delete Confirmation' showCloseIcon={true} buttons={this.buttons}
                                ref={dialog => this.dialogInstance = dialog}
                                visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                    content="" />&nbsp;Do you want to delete the abbreviation?
                                Note: Press 'Yes' to delete or press 'No' to decline.
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</DialogComponent>
                            {/*Dialog Component For  Deletion all Confirmation*/}
                            <DialogComponent width='400px' animationSettings={this.settings}
                                header='Delete All' showCloseIcon={true} buttons={this.deleteAllButton}
                                ref={dialog => this.dialogInstance = dialog}
                                visible={this.state.hideDeleteAllPopup} close={this.dialogClose}>
                                <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                    content="" />&nbsp;Do you want to delete all the abbreviation?<br />Note: Press 'Yes' to delete or press 'No' to decline.
                            </DialogComponent>

                            <DialogComponent width='400px' animationSettings={this.settings}
                                header='Incorrect Password' showCloseIcon={true} buttons={this.incorrectPasswordButtons}
                                ref={dialog => this.dialogInstance = dialog}
                                visible={this.state.hideIncorrectPassword} close={this.IncorrectPassworddialogClose}>
                                Please type "Delete"
                            </DialogComponent>


                            <DialogComponent width='400px' animationSettings={this.settings}
                                header='Delete Confirmation' showCloseIcon={true} buttons={this.textAreaConfir}
                                ref={dialog => this.dialogInstance = dialog}
                                visible={this.state.hideTextAreaPopup} close={this.DeletedialogClose}>
                                Please type "Delete" for confirmation<input type="text" id="deleteInputFromUser" />
                            </DialogComponent>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/projectmgmt/MultiLingualData/AbbreviationText.js